module.exports = __webpack_public_path__ + "static/media/totalhealthcover.f9704fe5.png";